<section class="card">
  <div class="card-header">
    <section class="logo">
      <img src="../../../assets/images/logo_blue_black.svg" alt="Innovian">
    </section>
  </div>
  <div class="card-body">
    <div *ngIf="loading$ | async">
      <app-loading-icon [text]="'Loading ' + loading$.getValue()" size="lg"></app-loading-icon>
    </div>
    <app-error-message error="There was a problem loading your companies." errorType="error" *ngIf="error$ | async"></app-error-message>
    <form *ngIf="(loading$ | async) === null && (error$ | async) === false" [formGroup]="form">
      <div class="form-group">
        <label for="context-company-selector">Company</label>
        <select class="form-control" id="context-company-selector" formControlName="company">
          <option disabled [ngValue]="null" hidden>Select a company</option>
          <option *ngFor="let company of contextsAvailable" [ngValue]="company.id">{{ company.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="context-property-selector">Property</label>
        <select class="form-control" id="context-property-selector" formControlName="property" *ngIf="form.get('company').valid && properties">
          <option disabled [ngValue]="null" hidden>Select a property</option>
          <option *ngFor="let property of properties" [ngValue]="property.id">{{ property.name }}</option>
        </select>
        <div class="form-control disabled" *ngIf="!form.get('company').valid">Select a company first.</div>
      </div>
    </form>
  </div>
  <div class="card-footer">
    <button class="btn btn-link" *ngIf="changingContext" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary btn-sm float-right" (click)="loadNewContext()" [attr.disabled]="(form.valid && (loading$ | async) === null) ? undefined : true" [style.opacity]="((loading$ | async) || (error$ | async)) ? 0 : 1">{{ (loading$ | async) === null ? "Load Property" : "Loading..." }}</button>
  </div>
</section>
